export default __webpack_public_path__ + "static/media/002-Ant Man.4b879979.svg";